import { Container, Grid } from "@mui/material";
import React from "react";

const Audit = () => {
    return(
        <div className="py-5">
            <Container>
                <Grid
                    container
                    justifyContent="center"
                    alignContent="center"
                    className="pb-md-5"
                >
                    <Grid
                        xs={12}
                    >
                        <h2 className="OS---sectionHeading">Audits</h2>
                    </Grid>
                    <Grid
                        xs={12}
                        className="text-center pt-4"
                    >
                        <h4>TBA</h4>
                    </Grid>
                </Grid>
            </Container>
        </div>
    );
}

export default Audit;